var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flix-text-success flix-text-center"},[(_vm.saving)?_c('div',{staticClass:"flex flex-center"},[_c('b-flix-loader')],1):_c('div',[_c('div',{staticClass:"ok"},[_c('b-flix-icon',{attrs:{"icon":"check"}})],1),_c('div',[_vm._v(" "+_vm._s(_vm.$t('message.successfullSaved'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }